import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  useMediaQuery,
  useTheme,
  Box,
  Typography,
  IconButton,
  Button,
  TableHead,
  Modal,
} from "@mui/material";
import EyeIcon from "../../common/assests/eyeicon.png";
import Adminimg from "../../common/assests/adminimg.png";
import CrossIcon from "../../common/assests/croosicon.png";
import EmailRoundedIcon from "@mui/icons-material/EmailRounded";
import CallIcon from '@mui/icons-material/Call';
import Paginations from "../../common/pagination/Paginations";
import { acceptVenderApi, allPendingVenderApi, rejectVenderApi } from "../../api";
import { useSelector } from "react-redux";
import Loader from "../../common/loader/Loader";
import UserImg from '../../common/assests/reyleafLogo.svg'
import { toast } from "react-toastify";

const PendingApprove = () => {
  const token = useSelector((state) => state?.user?.user?.token);

  const theme = useTheme();
  const isSmallScreen = useMediaQuery("(max-width:480px)");
  const [rejectMessage,setRejectMessage]=useState("");
  const [pendingVendorData,setPendingVendorData]=useState([]);
  const [loading,setLoading]=useState(false);
  const [change,setChange]=useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState();
  const [open, setOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [rejectModalOpen, setRejectModalOpen] = useState(false);
  const handleRejectModalOpen = () => setRejectModalOpen(true);
  const handleRejectModalClose = () => setRejectModalOpen(false);


  const handlePendingVendor = async () => {
    try {  
      setLoading(true);
      const response = await allPendingVenderApi({token,currentPage});
      setPendingVendorData(response?.users|| []);
      // console.log("pending veorr",response);
      setCurrentPage(response?.currentPage)
      setTotalPages(response?.totalPages)
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error", error);
    }
  };

  useEffect(()=>{
    handlePendingVendor()
  },[currentPage,change])


  // handle accept
  const handleAcceptVendor=async(id)=>{
    const isConfirmed = window.confirm("Are you sure, you want to Accept  this vendor?");
    if (!isConfirmed) {
      return;
    }
    try {  
      const response = await acceptVenderApi({token,id,vendorStatus:2});
      setChange(!change)
      toast.success(response.message)
     
    } catch (error) {
      toast.error(error.message)
      console.log("error", error);
    }
  }

// reject
  const handleRejectVendor=async(id)=>{
    if(!rejectMessage){
      toast.warning("Reason Required")
      return
    }
    const isConfirmed = window.confirm("Are you sure, you want to Reject this vendor?");
    if (!isConfirmed) {
      return;
    }
    try {  
      const response = await rejectVenderApi({token,id,vendorStatus:3,rejectReason:rejectMessage})
      setRejectMessage("");
      setChange(!change)
      toast.success(response.message)
      handleRejectModalClose(); 
      handleClose();
    } catch (error) {
      toast.error(error.message)
      console.log("error", error);
    }
  }


  const handleClickOpen = (row) => {
    setSelectedRow(row);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    // setSelectedRow(null);
  };

  const getStatusLabel = (status) => {
    switch (status) {
      case 1:
        return 'Unverified';
      case 2:
        return 'Active';
      case 3:
        return 'Rejected';
      // case 4:
      //   return 'Deleted';
      //   case 5:
      //     return 'Rejected';
      default:
        return '-';
    }
  };

  const tableHeaders = [
    "Business Name",
    "Email",
    "Mobile no",
    "Address",
    "Status",
    "Action"
  ]

  const handlePageChange = (page) => {
    setLoading(true);
    setCurrentPage(page);
  };

  return (
    <div>

      {
        loading ? (
          <Loader variant="table" />
        ):(
          <Box sx={{ marginTop: "40px", marginBottom: "30px" }}>
          <TableContainer
            component={Paper}
            sx={{ padding: "26px", borderRadius: "24px" }}
          >
            <Table sx={{ minWidth: 650 }} aria-label="custom table">
             <TableHead>
                <TableRow>
                  {tableHeaders.map((header) => (
                    <TableCell
                      key={header}
                      sx={{
                        color: "#362B24",
                        fontWeight: "600",
                        fontFamily: "Heebo",
                        fontSize: "16px",
                      }}
                    >
                      {header}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
  
              <TableBody>
              {pendingVendorData.length >0 ?(              
                pendingVendorData.map((row) => (
            
                  <TableRow
                    key={row._id}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell>
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <img
                          src={UserImg}
                          alt={"vendor-img"}
                          style={{
                            height: "45px",
                            width: "45px",
                            marginRight: "8px",
                            borderRadius: "50%",
                          }}
                        />
                        <Typography sx={{whiteSpace:'nowrap'}}>{row?.fullname||"-"}</Typography>
                      </Box>
                    </TableCell>
                    <TableCell>{row?.email||"-"}</TableCell>
                    <TableCell>{row?.phone||"-"}</TableCell>
                    <TableCell> 
                      {
                        row?.address 
                          ? [
                              row.address.address || "-",
                              // row.address.city || "",
                              // row.address.state || "",
                              // row.address.country || "",
                              // row.address.zipcode || ""
                            ]
                            .filter(Boolean) 
                            .join(", ")
                          : "-" }
                      </TableCell>

                    <TableCell>{getStatusLabel(row?.vendorStatus||"-")}</TableCell>
                    <TableCell
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "5px",
                      }}
                    >
                      <IconButton onClick={() => handleClickOpen(row)}>
                        <img
                          src={EyeIcon}
                          alt="viewicon"
                          style={{
                            height: isSmallScreen ? "35px" : "42px",
                            width: isSmallScreen ? "35px" : "45px",
                          }}
                        />
                      </IconButton>
                      <Button
                      onClick={()=>handleAcceptVendor(row?._id)}
                        sx={{
                          width: "94px",
                          height: "44px",
                          borderRadius: "15px",
                          backgroundColor: "#065F46",
                          color: "#FFF",
                          textTransform: "none",
                          "&:hover": {
                            backgroundColor: "#065F46",
                          },
                          flexShrink: 0,
                        }}
                      >
                        Accept
                      </Button>
                      <Button
                          onClick={() => {
                              setSelectedRow(row); 
                              handleRejectModalOpen();
                            
                            }}
                        sx={{
                          width: "94px",
                          height: "44px",
                          borderRadius: "15px",
                          backgroundColor: "#EA001B",
                          color: "#FFF",
                          textTransform: "none",
                          "&:hover": {
                            backgroundColor: "#EA001B",
                          },
                          flexShrink: 0,
                        }}
                      >
                        Reject
                      </Button>
                    </TableCell>
                  </TableRow>
                ))
              ):(
                <TableRow align='center'>
                <TableCell colSpan={tableHeaders.length}>
                  <Typography align="center">No Data Found</Typography>
                </TableCell>
              </TableRow>
              )}
             
                
              </TableBody>
             
            </Table>
  
            <Paginations
         totalPages={totalPages}
         currentPage={currentPage}
         onPageChange={handlePageChange}
         disabled={loading}
        />
  
          </TableContainer>
        </Box>
        ) 
      }

     {/* view modal  */}

  
<Modal open={open} onClose={handleClose}>
    <Box
      sx={{
        maxHeight: "75vh",
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        maxWidth: "681px",
        width: "90%",
        bgcolor: "#FFFFFF",
        borderRadius: "32px",
        boxShadow: 24,
        overflowY: "auto",
        p: 4,
        "&::-webkit-scrollbar": {
          display: "none",
        },
      }}
    >
      {/* Header */}

  
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "baseline",
        }}
      >
        <Typography
         
          sx={{
            marginBottom: "16px",
            color: "#362B24",
            fontSize: "20px",
            fontWeight: "700",
          }}
        >
          Vendor Detail
        </Typography>
  
        <IconButton onClick={handleClose}>
          <img
            src={CrossIcon}
            alt="Close"
            style={{ width: "20px", height: "20px", cursor: "pointer" }}
          />
        </IconButton>
      </Box>
  
      {/* Modal Content */}
      
      {selectedRow && (
        <Box sx={{marginTop:1 }}>
          <Box sx={{ textAlign: "center",  }}>
            <img
              src={UserImg}
              alt="User"
              style={{
                  width: "30%",
                  height: "auto",
                  maxWidth: "128px",
                marginBottom: "10px",
                borderRadius: "128px",
              }}
            />
            <Typography
              sx={{
                fontSize: "20px",
                fontWeight: "600",
                color: "#362B24",
                marginBottom: "8px",
                marginTop:'10px'
              }}
            >
              {selectedRow?.fullname||"-"}
            </Typography>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginBottom: "16px",
                color:'#065F46',
                fontSize:'14px'
              }}
            >
              <EmailRoundedIcon sx={{ marginRight: "4px" }} />
              <Typography>{selectedRow?.email||"-"}</Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginBottom: "8px",
                color:'#065F46',
                fontSize:'14px'
              }}
            >
              <CallIcon sx={{ marginRight: "4px" }} />
              <Typography>{selectedRow?.phone||"-"}</Typography>
            </Box>
          </Box>
  
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(110px, 1fr))",
              gap: 2,
             
              marginTop:'30px',
            }}
          >
            <Box>
              <Typography
                sx={{
                  fontWeight: "400",
                  opacity: "0.6",
                  color: "#362B24",
                }}
              >
                Address
              </Typography>
              <Typography sx={{ fontWeight: "500", fontSize: "16px" }}>
                {selectedRow?.address?.address||"-"}
              </Typography>
            </Box>
            <Box>
              <Typography
                sx={{
                  fontWeight: "400",
                  opacity: "0.6",
                  color: "#362B24",
                }}
              >
                City
              </Typography>
              <Typography sx={{ fontWeight: "500", fontSize: "16px" }}>
                {selectedRow?.address?.city||"-"}
              </Typography>
            </Box>
            <Box>
              <Typography
                sx={{
                  fontWeight: "400",
                  opacity: "0.6",
                  color: "#362B24",
                }}
              >
                State
              </Typography>
              <Typography sx={{ fontWeight: "500", fontSize: "16px" }}>
                {selectedRow?.address?.state||"-"}
              </Typography>
            </Box>
            <Box>
              <Typography
                sx={{
                  fontWeight: "400",
                  opacity: "0.6",
                  color: "#362B24",
                }}
              >
                Country
              </Typography>
              <Typography sx={{ fontWeight: "500", fontSize: "16px" }}>
                {selectedRow?.address?.country||"-"}
              </Typography>
            </Box>
            <Box>
              <Typography
                sx={{
                  fontWeight: "400",
                  opacity: "0.6",
                  color: "#362B24",
                }}
              >
                Zip Code
              </Typography>
              <Typography sx={{ fontWeight: "500", fontSize: "16px" }}>
                {selectedRow?.address?.zipcode||"-"}
              </Typography>
            </Box>
          </Box>
  
          <Box>
            <Typography
              sx={{
                fontWeight: "600",
                marginTop:'20px',
                color: "#362B24",
               
                fontSize:'15px',
  
              }}
            >
              Description
            </Typography>
            <Typography
              sx={{
                fontWeight: "400",
                fontSize: {xs:'12px',sm:'13px',md:'16px'},
                color: "#362B24",
                opacity:0.6, marginTop:'8px',
                
              }}
            >
             {selectedRow?.bio||"N/A"}
            </Typography>
          </Box>
  
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              gap: "10px",
              flexWrap: "wrap", marginTop:'25px',
            }}
          >
            <Button
             onClick={() => {
              handleAcceptVendor(selectedRow._id)
              handleClose();
            }}
              sx={{
                width: "180px",
                height: "50px",
                borderRadius: "15px",
                backgroundColor: "#065F46",
                color: "#FFF",
                textTransform: "none",
                "&:hover": {
                  backgroundColor: "#065F46",
                },
                flexShrink: 0,
              }}
            >
              Accept
            </Button>
            <Button
          sx={{
            width: "180px",
            height: "50px",
            borderRadius: "15px",
            backgroundColor: "#EA001B",
            color: "#FFF",
            textTransform: "none",
            "&:hover": {
              backgroundColor: "#EA001B",
            },
            flexShrink: 0,
          }}
          onClick={()=>
            handleRejectModalOpen()
          
          }
        >
          Reject
        </Button>
          </Box>
        </Box>
      )}
        </Box>
          </Modal>

{/* rejected modal */}


<Modal
        open={rejectModalOpen}
        onClose={handleRejectModalClose}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box
          sx={{
            maxWidth: '538px',
            width:'90%',
            height: '418px',
            borderRadius: '32px',
            backgroundColor: '#FFF',
            display: 'flex',
            flexDirection: 'column', 
            p: 3,
            mx: 'auto',
            my: 3,
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              mb: 2,
            }}
          >
            <Typography
              sx={{
                color: '#362B24',
                fontSize: '20px',
                fontWeight: '700',
              }}
            >
              Reason for Rejection
            </Typography>

            <IconButton onClick={handleRejectModalClose}>
              <img
                src={CrossIcon}
                alt="Close"
                style={{ width: '20px', height: '20px', cursor: 'pointer' }}
              />
            </IconButton>
          </Box>

          <Typography sx={{  color: '#362B24',
          marginTop:'15px',
                fontSize: '14px',
                fontWeight: '600',}}>
          Type your Reason
          </Typography>

          <textarea
            placeholder="Type here"
            // value={rejectMessage}
            onChange={(e) => {
              if (e.target.value.trim() !== "" || e.target.value === "") {
              setRejectMessage(e.target.value)}
            }
            }
            style={{
              maxWidth: '470px',
              width:'100%',
              height: '202px',
              borderRadius: '18px',
              border: '1.4px solid #362B24',
             
              backgroundColor: '#FFF',
              padding: '16px',
              fontSize: '16px',
              resize: 'none', 
              marginTop:'15px',
              outline:'none'
            }}
          />

        <Box sx={{ display:'flex',
          justifyContent:'center',mt:3}}>
        <Button
         onClick={() => {
            handleRejectVendor(selectedRow?._id)
            
          }}
        sx={{
          width: "196px",
          height: "50px",
          borderRadius: "15px",
          backgroundColor: "#EA001B",
          color: "#FFF",
          textTransform: "none",
         
          "&:hover": {
            backgroundColor: "#EA001B",
          },
          flexShrink: 0,
        }}
       
      >
        Reject
      </Button>
        </Box>
</Box>
</Modal>
    </div>
  );
};

export default PendingApprove;